import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import AuthPage from './pages/AuthPage';
import Dashboard from './pages/Dashboard';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/auth" element={<AuthPage />} />
        {/* the old setup page asked for a topographer nothing read, and a lens
            type that is now a switch on the dashboard itself */}
        <Route path="/select" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<ProtectedRoute element={<Dashboard lens="scleral" />} />} />
        <Route path="/dashboard/corneal" element={<ProtectedRoute element={<Dashboard lens="corneal" />} />} />
        {/* the old upload pages are the dashboard now, and fit submission and
            history never worked; bookmarks land somewhere useful */}
        <Route path="/upload/scleral" element={<Navigate to="/dashboard" replace />} />
        <Route path="/upload/corneal" element={<Navigate to="/dashboard/corneal" replace />} />
        <Route path="/submit-fit" element={<Navigate to="/dashboard" replace />} />
        <Route path="/fit-history" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Router>
  );
}

export default App;